'use client';
import { useState, useEffect } from 'react';

// End-of-article 👍/👎. The widget itself is a minor engagement nicety — the real value is
// server-side: votes feed a per-article score in he_article_feedback that the admin quality
// panel (/admin/article-quality) sorts worst-first, turning "which articles should we
// rewrite" from a guess into a queue. One vote per browser (localStorage guard, not an
// account system — this is a signal, not a poll that needs to be un-gameable).
export default function ArticleFeedback({ articleId }: { articleId: number }) {
  const key = `af_voted_${articleId}`;
  const [voted, setVoted] = useState<'up' | 'down' | null>(null);

  useEffect(() => {
    try { setVoted((localStorage.getItem(key) as 'up' | 'down' | null) || null); } catch {}
  }, [key]);

  function vote(v: 'up' | 'down') {
    if (voted) return;
    setVoted(v);
    try { localStorage.setItem(key, v); } catch {}
    fetch('/api/article-feedback', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ articleId, vote: v }),
    }).catch(() => {});
  }

  return (
    <div className="mt-10 rounded-2xl p-5 text-center" style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}>
      <div className="text-sm font-bold mb-3" style={{ color: '#0f172a' }}>המאמר הזה עזר לכם?</div>
      <div className="flex justify-center gap-3">
        <button onClick={() => vote('up')} disabled={!!voted}
          className="rounded-full px-5 py-2 font-bold text-sm"
          style={{
            border: `1.5px solid ${voted === 'up' ? '#16a34a' : '#e2e8f0'}`,
            background: voted === 'up' ? '#f0fdf4' : '#fff',
            color: voted === 'up' ? '#15803d' : '#334155',
            cursor: voted ? 'default' : 'pointer', opacity: voted && voted !== 'up' ? 0.5 : 1,
          }}>
          👍 עזר
        </button>
        <button onClick={() => vote('down')} disabled={!!voted}
          className="rounded-full px-5 py-2 font-bold text-sm"
          style={{
            border: `1.5px solid ${voted === 'down' ? '#dc2626' : '#e2e8f0'}`,
            background: voted === 'down' ? '#fef2f2' : '#fff',
            color: voted === 'down' ? '#b91c1c' : '#334155',
            cursor: voted ? 'default' : 'pointer', opacity: voted && voted !== 'down' ? 0.5 : 1,
          }}>
          👎 פחות
        </button>
      </div>
      {voted && <div className="text-xs mt-2" style={{ color: '#94a3b8' }}>תודה על המשוב!</div>}
    </div>
  );
}
